import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';
import { DeliveryStatus } from '../../../../../constants/status';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2/delivery';

async function auctionApprove(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/approve`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function auctionReject(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/reject`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function addFund(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/add`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function clientFundSettle(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/client-settle`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryGroups(filters) {
  const mappedFilters = { ...filters };

  if (filters.status) {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/groups?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryAuctions(filters) {
  const { groupId, ...otherFilters } = filters;

  const mappedFilters = { ...otherFilters };

  if (filters.status) {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/${groupId}?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export {
  addFund,
  getDeliveryGroups,
  getDeliveryAuctions,
  auctionApprove,
  auctionReject,
  clientFundSettle,
};
